/* eslint-disable jsx-a11y/alt-text */
import PropTypes from 'prop-types'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { connect } from 'react-redux'
import Base from '../../containers/BaseContainer'

import classNames from 'classnames'
import globalStyles from '../../styles/styles.module.scss'
import styles from './Menu.module.scss'

import Constants from '../../services/constants/Constants'
import { hasAuth } from '../../ContentUtils'
import { Link } from 'react-router-dom'

export const buildItems = ['design', 'navigation', 'contents', 'users', 'datasources', 'library']
export const distributeItems = ['deployment', 'api', 'cgu', 'privacyPolicy']
export const animateItems = ['notification']
export const measureItems = ['analytics']

export const authItems = {
  navigation: Constants.AuthConstants.UPDATE_NAVIGATION,
  users: Constants.AuthConstants.MANAGE_USERS,
  deployment: Constants.AuthConstants.DEPLOYMENT,
  cgu: Constants.AuthConstants.DEPLOYMENT,
  privacyPolicy: Constants.AuthConstants.DEPLOYMENT,
  api: Constants.AuthConstants.MANAGE_KEYS,
  notification: Constants.AuthConstants.CAN_NOTIFY,
}

class Menu extends Base {

  constructor(props) {
    super(props)
    this._bind('_renderVersion', '_renderItems', '_showVersion', '_getRootVersion', '_handleAppChange')
    this.state = {
      showVersion: false,
    }
  }

  _getAppTitle() {
    let appTitle = ''
    let that = this
    if (this.props.currentApp.name) {
      this.props.currentApp.name.translations.forEach(function (tr) {
        if (tr.locale.code === that.props.lang) appTitle = tr.translation
      })
    }
    return appTitle
  }

  _getAppIcon() {
    let mediaId = null
    if (this.props.currentApp.logo && this.props.currentApp.logo.medias.length) {
      let that = this
      this.props.currentApp.logo.medias.forEach(function (tr) {
        if (tr.locale.code === that.props.lang && tr.media) {
          mediaId = tr.media.id
        }
      })
    }
    if (mediaId) {
      let iconURL = Constants.UrlsConstants.urlServer + Constants.UrlsConstants.mediaMiniature +
        mediaId + Constants.UrlsConstants.authTokenParam + '&' + new Date().getTime()
      return <img src={iconURL} />
    } else {
      return <img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" alt="" />
    }
  }

  _getAppVersion() {
    if (this.props.currentApp.version) {
      return this.props.currentApp.version
    }
  }

  _getRootVersion() {
    if (this.props.globalApp.version) {
      return this.props.globalApp.version
    }
  }

  _renderItems(item, index, props) {
    let classList = classNames(styles.menuIcon, styles[item])
    let liClassList = classNames(styles.item, props.selectedMenuItem === item ? styles.active : null)
    return (
      <Link
        to={item}
        key={index}
      >
        <li
          id={item}
          data-linkid={item}
          className={liClassList}
        >
          <div className={classList}></div>
          {I18n.t('Menu.' + item)}
        </li>
      </Link>
    )
  }

  _renderVersion(item, index, props) {
    return (
      <Link key={index} to={`/${Constants.RoutesConstants.app.dashboard}/${item.id}/dashboard`}>
        <div
          id={'app' + index}
          className={styles.version}
          onClick={this._handleAppChange}>{item.version}
        </div>
      </Link>
    )
  }

  _showVersion(event) {
    this.setState({ showVersion: !this.state.showVersion })
  }

  _handleAppChange(event) {
    let id = event.currentTarget.id.replace('app', '')
    if (!isNaN(parseInt(id, 0))) {
      this.props.onAppChange(parseInt(id, 0))
    } else {
      this.props.onAppChange(-1)
    }
    this.setState({ showVersion: false })
  }

  render() {
    let menuClassList = classNames(styles.menu, this.props.isMenuOpen ? null : styles.smallMenu)
    let menuContainerClassList = classNames(globalStyles.menu,
      this.props.appEditorOpened ? globalStyles.blurred : null,
      this.props.isMenuOpen ? null : globalStyles.smallMenu,
      this.props.isHeaderDisplayed ? null : globalStyles.fullMenu,
      this.props.currentApp.id && this.props.path.indexOf('account') === -1 && this.props.path.indexOf('admin') === -1
        ? globalStyles.menuDisplayed : null)
    let appStatusClassList = classNames(styles.appStatus, this.props.currentApp.status ===
      Constants.AppsConstants.STATUS.CONSTRUCTION
      ? styles.inProgress : styles.publishing)
    let appIconClassList = classNames(styles.appIcon,
      this.props.currentApp.logo && this.props.currentApp.logo.medias.length ? null : styles.defaultIcon)
    let dashboardClassList = classNames(styles.item,
      this.props.selectedMenuItem === 'applicationBuilder' ? styles.active : null)
    let versionsClassList = classNames(styles.versions, this.state.showVersion === true ? styles.show : null)

    let canDeploy = hasAuth(this.props.user, Constants.AuthConstants.DEPLOYMENT)
    let accessApi = hasAuth(this.props.user, Constants.AuthConstants.MANAGE_KEYS)
    let accessNotif = hasAuth(this.props.user, Constants.AuthConstants.CAN_NOTIFY)

    return (
      <div className={menuContainerClassList}>
        <aside className={menuClassList}>
          <div className={styles.row}>
            <div className={styles.burger} onClick={this.props.onMenuClick}></div>
          </div>
          <div className={styles.appRow}>
            <div className={appIconClassList}>
              {!this.props.isReplacing ? this._getAppIcon() : null}
            </div>
            <div className={styles.appInfos}>
              <div className={styles.appTitleAndVersion}>
                <div className={styles.appTitle}>{this._getAppTitle()}</div>
                {this.props.globalApp.children !== undefined &&
                  this.props.globalApp.children.length > 0
                  ? <div className={styles.appVersion} onClick={this._showVersion}>
                    <div className={styles.version}>{this._getAppVersion()}</div>
                  </div> : null}
              </div>
              <div className={appStatusClassList}>
                {I18n.t('STATUS.' + this.props.currentApp.status)}
                <div
                  className={this.props.canEditApp ? styles.editApp : null}
                  onClick={() => {
                    if (this.props.canEditApp && this.props.currentApp && this.props.onAppEdit) {
                      this.props.onAppEdit(this.props.currentApp)
                    }
                  }} />
              </div>
            </div>
          </div>
          <div className={versionsClassList}>
            {this.props.globalApp.children
              ? this.props.globalApp.children.map((child, index) => {
                if (this.props.currentApp.id === child.id) return ''
                return this._renderVersion(child, index, this.props)
              })
              : null
            }
            <Link to={`/${Constants.RoutesConstants.app.dashboard}/${this.props.globalApp.id}/dashboard`}>
              <div className={styles.version} id='appOriginal'
                onClick={this._handleAppChange}>{this._getRootVersion()}
              </div>
            </Link>
          </div>
          <Link to="dashboard">
            <div data-linkid='applicationBuilder' className={dashboardClassList}>
              <div className={styles.dashboard}></div>
              {I18n.t('Menu.dashboard')}
            </div>
          </Link>
          <ul className={styles.list}>
            <li className={styles.itemTitle}>{I18n.t('Menu.build')}</li>
            {buildItems.map((item, index) => {
              if (!authItems[item] || hasAuth(this.props.user, authItems[item])) {
                return this._renderItems(item, index, this.props)
              } else {
                return null
              }
            })}
            {accessNotif ? <li className={styles.itemTitle}>{I18n.t('Menu.animate')}</li> : null}
            {accessNotif ? animateItems.map((item, index) => {
              return this._renderItems(item, index, this.props)
            }) : null}
            <li className={styles.itemTitle}>{I18n.t('Menu.measure')}</li>
            {measureItems.map((item, index) => {
              return this._renderItems(item, index, this.props)
            })}
            {canDeploy || accessApi ? <li className={styles.itemTitle}>{I18n.t('Menu.distribute')}</li> : null}
            {canDeploy || accessApi ? distributeItems.map((item, index) => {
              if (!authItems[item] || hasAuth(this.props.user, authItems[item])) {
                return this._renderItems(item, index, this.props)
              } else {
                return null
              }
            }) : null}
          </ul>
        </aside>
      </div>
    )
  }
}

Menu.propTypes = {
  onMenuClick: PropTypes.func.isRequired,
  isMenuOpen: PropTypes.bool.isRequired,
  isHeaderDisplayed: PropTypes.bool.isRequired,
  selectedMenuItem: PropTypes.string.isRequired,
  currentApp: PropTypes.object.isRequired,
  globalApp: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  onAppChange: PropTypes.func.isRequired,
  contents: PropTypes.array,
  path: PropTypes.string,
  onAppEdit: PropTypes.func,
  canEditApp: PropTypes.bool,
}

const mapStateToProps = ({ authWS: { user } }) => ({
  user,
})

const mapDispatchToProps = (dispatch) => ({
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(Menu)
